import styled from '@emotion/styled';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { useAtom, useAtomValue } from 'jotai';

import {
  insurancePdfPathAtom,
  isInsurancePdfOpenAtom,
} from '../../../modules/patientList/atoms';

const VideaViewer = styled(Viewer)`
  background-color: #666;
`;

const VideaCloseButton = styled(Button)`
  &.close-button {
    min-width: 1.5em;
    height: 0.6em;
    position: absolute;
    z-index: 1001;
    top: 0.6em;
    right: 0.1em;
    font-size: 1.3em;
    padding: 0;
  }
  &.MuiButtonBase-root {
    outline: none;
  }
`;

const VideaDialog = styled(Dialog)`
  .MuiPaper-root {
    box-shadow: 0 0 0.5em rgba(0, 0, 0, 0.1);
    border: 0.4em solid rgba(0, 0, 0, 0.01);
    border-radius: 0.75em;
  }
`;

const VideaDialogTitle = styled(DialogTitle)`
  display: flex;
  align-items: center;
`;

export const PdfViewerV2 = () => {
  const insurancePdfPath = useAtomValue(insurancePdfPathAtom);
  const [isInsurancePdfOpen, setIsInsurancePdfOpen] = useAtom(
    isInsurancePdfOpenAtom,
  );

  const pdfjsVersion = `3.11.174`;
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  return (
    <VideaDialog
      open={isInsurancePdfOpen}
      onClose={() => setIsInsurancePdfOpen(false)}
      PaperProps={{
        elevation: 0,
      }}
    >
      <VideaDialogTitle>
        Insurance Claim Summary
        <VideaCloseButton
          onClick={() => setIsInsurancePdfOpen(false)}
          autoFocus
          className="close-button"
        >
          &times;
        </VideaCloseButton>
      </VideaDialogTitle>
      <div>
        <Worker
          workerUrl={`https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsVersion}/pdf.worker.min.js`}
        >
          <div
            style={{
              height: '650px',
              width: '600px',
              marginLeft: 'auto',
              marginRight: 'auto',
            }}
          >
            <VideaViewer
              fileUrl={insurancePdfPath}
              plugins={[defaultLayoutPluginInstance]}
            />
          </div>
        </Worker>
      </div>
    </VideaDialog>
  );
};
